import React, { useState } from "react";
import Api from "../common/api";
import "./../styles/Timeline.scss";

const History = () => {
    const lang = localStorage.getItem("lang");
    const [currentHistory, setCurrentHistory] = useState([]);

    React.useEffect(() => {
        Api.get("/home/gethistory?lang=" + lang).then((res) => {
            setCurrentHistory(res.data);          
        });
    });

    return (
        <div id="timeline">
            <div className="midline"></div>
            {
                currentHistory.map((row) => {
                    return (
                        <div className={row.CssClass}>
                            { row.FirstRecord ? <span className="ylabel first-year">{row.YearName}</span> : <span className="ylabel">{row.YearName}</span>}

                            {
                                row.Tags.map((child) => {
                                    return (
                                        <div className={child.CssClass}>
                                            { child.Line ? <span className="line"></span> : null }

                                            <div className={child.TagCssClass}>
                                                <span className="dlabel">{child.MonthName}</span>
                                                { child.ImageExist ? <img src={child.ImageURL}></img> : null }
                                                <h1>{child.Subject}</h1>
                                                <p>{child.Content}</p>
                                            </div>
                                        </div>
                                    );
                                })
                            }

                        </div>
                    );
                })
            }
        </div>
    );
};

export default History;